import { Button } from '@enterprise-ui/canvas-ui-react'
import styled from 'styled-components'
import './ModeSelectBar.css'

export const MODE_BUTTON_HEIGHT = 80
export const ModeButtonContainer = styled.footer`
  display: flex;
  height: ${MODE_BUTTON_HEIGHT}px;
  .C-ButtonGroup {
    flex-grow: 1;
  }

  .C-ButtonGroup__ListItem {
    flex-grow: 1;
  }

  .C-Button {
    padding: 0;
    border-radius: 0px !important;
  }
`

export const ModeButton = styled(Button)`
  background: #272727 !important;
  border: none;
  color: #c4c4c4;
  font-size: 12px;
  flex-direction: column;
  gap: 2px;
  position: relative;

  &.\--type-primary {
    svg {
      color: #76b7f7;
    }
    color: #fff;
  }

  &.\--type-submit-destructive {
    svg {
      color: var(--canvas-icon-color--alert);
    }
  }

  &.\--type-default.alert {
    svg {
      color: var(--canvas-icon-color--error);
    }
  }
`

export const NotificationBadge = styled.span`
  position: absolute;
  top: 12px;
  left: calc(50% + 8px);
  height: 9px;
  width: 9px;
  border-radius: 50%;
  background-color: #e0342b;
  border: 2px solid #272727;
  pointer-events: none;
`
